module.exports = __webpack_public_path__ + "img/ccf-4.ed72e792.webp";